import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/play-store.png")